"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.aboutContainer = aboutContainer;
const React = __importStar(require("react"));
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const Elements = __importStar(require("@genesys/client-core/lib/elements"));
const AuthorizationTools = __importStar(require("@genesys/shared/lib/authorization"));
const GraphQLQuery = __importStar(require("@genesys/client-core/lib/graphql-query"));
const UserProfile = __importStar(require("@genesys/client-core/lib/user-profile"));
const queryProduct = (0, graphql_tag_1.default) `
  query AboutContainerProduct {
    product {
      serverInformation {
        id
        clientCommitInfo
        serverCommitInfo
        version
        serverName
        userDbInfo
        productDbInfo
      }
    }
  }
`;
function aboutContainer({}) {
    return (React.createElement(GraphQLQuery.QueryProductSimple, { query: queryProduct, variables: {} }, productData => (React.createElement(UserProfile.UserProfile, null, ({ applicationClaims }) => {
        const link = "http://pinvoke.com/";
        const { clientCommitInfo, productDbInfo, version, serverCommitInfo, serverName, userDbInfo } = productData.product.serverInformation;
        const hasDeveloperPermission = AuthorizationTools.checkPermission(applicationClaims, AuthorizationTools.genesysUserClaims.developer);
        return (React.createElement(Elements.FlexContainerStack, null,
            React.createElement(Elements.ContainerWithBorder, null,
                React.createElement("img", { src: "/assets/images/munterslogo2.png", width: "170" }),
                React.createElement("img", { src: "/assets/images/genesys.png", style: { display: "block" } })),
            React.createElement(Elements.StyledTable, null,
                React.createElement("tbody", null,
                    row("Genesys", "Munters Selection Software is developed by Divid AB"),
                    hasDeveloperPermission && row("Version", version),
                    hasDeveloperPermission &&
                        row("Client commit", clientCommitInfo),
                    hasDeveloperPermission &&
                        row("Server commit", serverCommitInfo),
                    hasDeveloperPermission && row("Server", serverName),
                    hasDeveloperPermission && row("ProductDb", productDbInfo),
                    hasDeveloperPermission && row("UserDb", userDbInfo),
                    row("Contact", "genesys@munters.se"),
                    row("Free icons from", React.createElement("a", { target: "_blank", href: link }, link))))));
    }))));
}
function row(left, right) {
    return (React.createElement("tr", null,
        React.createElement("td", null, left),
        React.createElement("td", null, right)));
}
//# sourceMappingURL=container-component.js.map